<template>
  <div>
    <div class="form-group ">
      <label for="fieldImage" class="control-label" :class="labelClasses">{{ inputLabel }}</label>
      <div class="input-group" :class="inputClasses">
        <span class="input-group-btn">
          <span
            class="btn btn-default btn-file"
            :disabled="uploaded"
            @click="triggerSelect">
            <span class="glyphicon glyphicon-open glyphicon"></span>
            <input
              type="file"
              ref="imageFile"
              style="display: none"
              @change="prepFile"
            >
          </span>
        </span>
        <input
          v-model="value.fileName"
          type="text"
          class="form-control admin-form-control"
          readonly
          >
      </div>
      <img id='img-upload'/>
      <spinner v-if="loading" message="Uploading..." text-fg-color="#fff" :speed="1"></spinner>
      <div class="image-uploader-btn-container" v-else>
        <button
          v-if="!uploaded"
          class="btn client-btn-primary btn-md"
          @click="uploadToS3">Upload Image</button>
        <button
          v-else
          class="btn client-btn-primary btn-md"
          @click="removeFromS3">Remove Image</button>
      </div>
    </div>
  </div>
</template>

<script>
import S3 from '../_helpers/awsS3.js'
import Spinner from 'vue-simple-spinner'
const crypto = require('crypto')

export default {
  name: 'FormImageUploader',
  props: {
    albumName: {
      type: String
    },
    inputLabel: {
      type: String,
      default () {
        return 'Image'
      }
    },
    value: {
      default () {
        return { fileName: null, randomString: null, imageKey: null, url: null }
      }
    },
    labelClasses: {
      type: Array,
      required: false,
      default () {
        return ['col-sm-3']
      }
    },
    inputClasses: {
      type: Array,
      required: false,
      default () {
        return ['col-sm-9']
      }
    }
  },
  components: {
    spinner: Spinner
  },
  data () {
    return {
      loading: false,
      file: null
    }
  },
  computed: {
    uploaded () {
      return this.value.url !== null
    }
  },
  mounted () {
  },
  methods: {
    triggerSelect (event) {
      if (this.uploaded) return
      this.$refs.imageFile.click()
    },
    prepFile () {
      const file = this.$refs.imageFile.files[0]
      if (!file) {
        return
      }
      this.file = file
      this.value.fileName = file.name
      this.value.randomString = this.generateRandomString()
      const albumPhotosKey = encodeURIComponent(this.albumName) + '/'
      this.value.imageKey = `${albumPhotosKey}${this.value.randomString}-${this.value.fileName}`
      this.$emit('input', this.value)
    },
    generateRandomString () {
      return crypto.randomBytes(20).toString('hex')
    },
    reset () {
      Object.assign(this.$data, this.$options.data())
    },
    removeFromS3 () {
      S3.removeFromS3(this.value.imageKey)
        .then(result => {
          this.value.url = null
          this.value.fileName = null
          this.value.randomString = null
          this.value.imageKey = null
          this.$emit('input', this.value)
          this.$emit('removed')
          alert('Successfully removed photo.')
        })
        .catch(err => {
          console.log(err)
          this.reset()
          alert('Submission error, please try again.', err.message)
        })
    },
    recordProgress (evt) {
      // console.log('Uploaded :: ' + parseInt((evt.loaded * 100) / evt.total) + '%')
    },
    uploadToS3 () {
      this.loading = true
      // TODO: might need to check if a previous image exists...
      S3.uploadToS3(this.value.imageKey, this.file, this.recordProgress)
        .then(result => {
          this.value.url = result.Location
          this.$emit('input', this.value)
          this.$emit('uploaded')
          this.loading = false
          alert('Submission successful.')
        })
        .catch(err => {
          console.log(err.message)
          alert('Submission error, please try again. ', err.message)
        })
    }
  }
}
</script>

<style scoped>
.image-uploader-btn-container {
  display: flex;
  justify-content: flex-end;
}

.btn-file {
  position: relative;
  overflow: hidden;
}
.btn-file input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  font-size: 100px;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  background: white;
  cursor: inherit;
  display: block;
}

#img-upload{
  width: 100%;
}
</style>
